import React from 'react';
import ErrorMessage from '~/components/Form/ErrorMessage';
import { useModals } from '~/contexts/ModalsContext';
import { EditIcon, RemoveIcon } from '~/public/static/svg/ItemActionIcons';
import {
  deleteVariation,
  getListFlowVariations,
} from '~/store/listFlow/slices/info';
import { getListFlowVariationError } from '~/store/listFlow/ui';
import { useAppDispatch, useAppSelector } from '~/store/store';

interface Props {}

const ListFlowVariationsTable: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const variations = useAppSelector(getListFlowVariations);
  const error = useAppSelector(getListFlowVariationError);
  const modals = useModals();

  if (!variations && error) {
    return <ErrorMessage errors={error} />;
  }

  if (!variations) {
    return null;
  }

  return (
    <div>
      <div className="mb-1 text-lg font-semibold">Options Available</div>
      <table className="mb-4 w-full">
        <thead>
          <tr>
            <th className="px-2 py-1 text-left">Name</th>
            <th className="px-2 py-1 text-left">Quantity</th>
            <th />
          </tr>
        </thead>

        <tbody>
          {variations.map((variation, i) => (
            <tr
              key={i}
              className="hover:bg-pastel-green-500 transition-colors duration-100"
            >
              <td className="rounded-l px-2 py-1 text-left">
                {variation.name}
              </td>
              <td className="px-2 py-1 text-left">{variation.quantity}</td>
              <td className="w-20 rounded-r px-2 py-1">
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={() =>
                      modals.openModal('variationsModal', { editingIndex: i })
                    }
                  >
                    <EditIcon />
                  </button>

                  <button
                    onClick={() => dispatch(deleteVariation({ index: i }))}
                  >
                    <RemoveIcon />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <ErrorMessage errors={error} />
    </div>
  );
};

export default ListFlowVariationsTable;
